module["exports"] = [
  "+49-1##-#######",
  "+49-1###-########"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/de/cell_phone/formats.js
 ** module id = 230
 ** module chunks = 0
 **/